import { useEffect, useRef, useState } from "react";
import PopupModal from "../../Popups/PopupModal";
import apiInstance from "../../../apiInstance";
import SubscriptionDetails from "./SubscriptionDetails";
import WebisteDetails from "./WebsiteDetails";
import SubscriptionPayments from "./SubscriptionPayments";
import { useNavigate, useParams } from "react-router-dom";

const DetailsPage = () => {
    
    const { subId } = useParams();
    const [subscriptionDetails, setSubscriptionDetails] = useState({});
    const [site, setSite] = useState({});
    const [payments, setPayments] = useState([]);
    const [error, setError] = useState("");
    const popupRef = useRef();
    const navigate = useNavigate();

    const updateSubscriptionHandler = (sub) => {
        setSubscriptionDetails(sub);
    }

    const deleteSubscriptionHandler = () => navigate("/devadmin/subscriptions");

    const deletePaymentHandler = (paymentId) => {
		setPayments((prev) => prev.filter(item => item.id !== paymentId));
    }

    const updatePaymentHandler = (payment) => {
        const updatedPayments = payments.map(item => item.id === payment.id ? {...item, ...payment} : item);
        setPayments(updatedPayments)
    }

    useEffect(() => {
        const fetchSubDetails = async () => {
            apiInstance
                .get(`/devadmin/subscription/${subId}`)
                .then((response) => {
                    setSubscriptionDetails(response.data.subscription?.subscriptionDetails || {});                   
                    setSite(response.data.subscription?.subscriptionDetails?.site || {});                  
                    setPayments(response.data.subscription?.payments || []);                                        
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load subscription details.");
                });
        }
        fetchSubDetails();
    }, [subId])

    return (
        <div className="mjsdev-dtl-page">
            <div className="mjsdev-dtl-header">
                <button className="mjsdev-dtl-back-btn mjs-btn" onClick={() => navigate("/devadmin/subscriptions")}>All Subscriptions</button>
                <div>
                    {/* <button 
                        className="mjs-btn"
                         onClick={(e) => {
                            if (popupRef.current) {
                                popupRef.current.openPopup(
                                    "editSubscription",
                                    { subscription: subscriptionDetails }
                                );
                            }
                        }}
                    >Edit</button>
                    <button 
                        className="mjs-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (popupRef.current) {
                                popupRef.current.openPopup(
                                    "deleteSubscription",
                                    { subId }
                                );
                            }
                        }}
                    >Delete</button> */}
                </div>
            </div>

            <div className="mjs-error">{error}</div>
            <div className="mjsdev-dtl-main-container">
                <SubscriptionDetails
                    subscriptionDetails={subscriptionDetails}
                />
                <WebisteDetails
                    site={site}
                />
                <SubscriptionPayments 
                    subscriptionDetails={subscriptionDetails}
                    payments={payments}
                    onEdit={(payment) => {
                        popupRef.current?.openPopup("editPayment", { payment });
                    }}
                    onDelete={(paymentId) => {
                        popupRef.current?.openPopup("deletePayment", { paymentId });
                    }}
                />
            </div>
            <PopupModal
                ref={popupRef}
                updateSubscription={updateSubscriptionHandler}
                deleteSubscription={deleteSubscriptionHandler}
                deletePayment={deletePaymentHandler}
                updatePayment={updatePaymentHandler}
            />
        </div>
    );
};

export default DetailsPage;
